const { BASE_URL } = require("./client");

const UPLOAD_VOLUNTEER_DATA = BASE_URL + "/api/volunteer";
module.exports = {
  UPLOAD_VOLUNTEER_DATA,
};
